import React, { AnchorHTMLAttributes, PropsWithChildren } from "react";
import { isInternalServiceUrl } from "src/utils/internalServices";

export default function ExternalLink({
  children,
  href,
  rel,
  ...props
}: PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>>) {
  const isInternalService = href ? isInternalServiceUrl(href) : false;
  const defaultRel = isInternalService
    ? "nofollow"
    : "noopener noreferrer nofollow";

  return (
    <a
      {...props}
      href={href}
      target="_blank"
      rel={rel ?? defaultRel}
    >
      {children}
    </a>
  );
}
